import _ from 'lodash';
export default class Cart {
  constructor(data) {
    const defaults = {
      packet: null,
      saldo: 0,
      saldoMultiplier: 1,
      serviceClass: null,
    };
    data = _.merge(defaults, data);
    this.packet = data.packet;
    this._saldo = data.saldo;
    this.saldoMultiplier = data.saldoMultiplier;
    this.serviceClass = data.serviceClass;
    this.saldoDiscount = null;
    this.topupMin = null;
  }

  packetPrice() {
    return this.packet ? this.packet.price : 0;
  }

  combinedPrice() {
    let currentSaldo = this.saldo;
    if (
      this.saldoDiscount !== null &&
      this.topupMin !== null &&
      this.topupMin <= currentSaldo
    ) {
      currentSaldo -= this.saldoDiscount;
    }
    return this.packetPrice() + currentSaldo;
  }

  empty() {
    return this.packet === null && this.saldo === 0;
  }

  get saldo() {
    return Math.ceil(this._saldo * this.saldoMultiplier);
  }

  set saldo(saldo) {
    this._saldo = saldo;
  }

  get rawSaldo() {
    return this._saldo;
  }
}
